import { render, staticRenderFns } from "./pur-card.vue?vue&type=template&id=7b782ae2&scoped=true"
import script from "./pur-card.vue?vue&type=script&lang=js"
export * from "./pur-card.vue?vue&type=script&lang=js"
import style0 from "./pur-card.vue?vue&type=style&index=0&id=7b782ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b782ae2",
  null
  
)

export default component.exports